module.exports = __webpack_public_path__ + "static/1-15c2d8a5f92f77a4d6fd16bc71593ab8.png";